import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import _ from 'lodash';

import 'react-datepicker/dist/react-datepicker.css';

class EditableCell extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: ''
        }
    }

    componentDidMount() {
        const { record, column } = this.props;
        this.setState({ value: record[column.dataIndex] })
    }

    componentWillReceiveProps(props) {
        if(props.record && props.column.calc) {
            const { record, column } = props;
            const value = column.calc(record, column);
            if(record[column.dataIndex] !== value) {
                record[column.dataIndex] = value;
                this.props.onChange && this.props.onChange(record)
            }
        }
    }

    handleDateChange = (date, event) => {
        this.setState({ 
            value: moment(date).format('DD.MM.YYYY') 
        }, () => this.handleBlur())
    }

    handleInputChange = (event) => {
        const { value } = event.target;
        const { record, column } = this.props;
        this.setState({ value: _.toNumber(value) ? _.toNumber(value) : value })
    }

    handleSelectChange = (event) => {
        const { record, column } = this.props;
        this.setState({ 
            value: event.target.value 
        }, () => this.handleBlur())        
    }

    handleBlur = () => {
        const { record, column } = this.props;
        const { value } = this.state;
        if(record[column.dataIndex] !== value) {
            record[column.dataIndex] = value;
            this.props.onChange && this.props.onChange(record)
        }
    }

    render() {
        const { record, column } = this.props;
        const { value } = this.state;

        if(column.calc) {
            return <div style={{ padding: 5, fontSize: 12, backgroundColor: '#F7F7F7' }}>
                {column.calc(record, column)}
            </div>
        }

        if(column.date) {
            return <DatePicker onChange={this.handleDateChange} 
                selected={value ? moment(value, 'DD.MM.YYYY') : undefined}
                dateFormat={'DD.MM.YYYY'} 
            />
        }

        if(column.select) {
            return <select value={value} onChange={this.handleSelectChange}>
                <option value={''} hidden></option>
                {_.map(
                    column.select,
                    item => <option value={item} key={item}>{item}</option>
                )}
            </select>
        }

        return <input value={value} onChange={this.handleInputChange}
            onBlur={this.handleBlur} style={{ width: '100%', padding: 5, fontSize: 12 }}
        />

    }
}
 
export default EditableCell;



// WEBPACK FOOTER //
// ./src/components/VirtualTable/EditableCell.jsx